import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<UploadCsvSuccessRecord>({})
export default class UploadCsvSuccessRecord extends Vue {
  @Prop({ default: {} })
  protected value!: SuccessRecordInterface;

  @Prop({ default: 0 })
  protected index!: number;
}

export interface SuccessRecordInterface {
  product?: string;
  product_id?: string;
  text?: string;
}
